// extracted by mini-css-extract-plugin
export default {"cls1":"TransactionReportForm-Checkbox_cls1__KnJYC","cls2":"TransactionReportForm-Checkbox_cls2__GLyBm TransactionReportForm-Checkbox_cls1__KnJYC"};